import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import { TranslateService } from '@ngx-translate/core';
import { FeedMessageService } from '@utils/feed-message.service';
import { MessageType } from '@models/index.model';
import { delay, from, map, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DownloadFileServices {
  tooltipTitle: any;
  msgError: any;

  constructor(public translate: TranslateService, private _notify: FeedMessageService) {
    translate.get(['GLOBAL.TOOLTIP']).subscribe(res => {
      this.tooltipTitle = res['GLOBAL.TOOLTIP'];
    });
    translate.get(['GLOBAL.UNKNOWN-ERROR-DOWNLOAD']).subscribe(res => {
      this.msgError = res['GLOBAL.UNKNOWN-ERROR-DOWNLOAD'];
    });
  }

  saveToFileSystem(response: Blob, fileName: string) {
    of(response)
      .pipe(
        map((blob: Blob) => URL.createObjectURL(blob)),
        tap((url: string) => this._openLink(url, fileName)),
        delay(5000),
        tap((url: string) => window.URL.revokeObjectURL(url))
      )
      .subscribe(); 
  }

  private _openLink(url: string, fileName: string): void {
    const a: HTMLAnchorElement = document.createElement('a');
    // Firefox requires the link to be in the body
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = fileName;
    a.click();
    // Remove the link when done
    document.body.removeChild(a);
  }
}
